<template>
  <model v-show="isShow">
    <div class="captcha-wrapper">
      <div id="captcha"></div>
    </div>
  </model>
</template>

<script>
import model from "@zj/model";
import initNECaptcha from "initNECaptcha";

export default {
  name: "ne-captcha",
  components: {
    model
  },
  data() {
    return {
      loading: null,
      isShow: false
    };
  },
  methods: {
    verify() {
      this.isShow = true;
      const _this = this;
      return new Promise(function(resolve, reject) {
        initNECaptcha(
          {
            captchaId: "3903296c63bc4bbf82b2e16fecc0a2ba",
            element: "#captcha",
            mode: "popup",
            width: "10rem",
            onReady: function() {
              _this.$loading.hide();
            },
            onVerify: function(err, data) {
              // $("#verify").addClass("hidden");
              if (_this.$loading) _this.$loading.hide("正在加载验证码");
              if (!err) {
                _this.$emit("verify", data.validate);
                resolve(data.validate);
                _this.isShow = false;
              } else {
                console.log("请求失败，请重试");
                // reject();
                // _this.verify();
              }
            }
          },
          function onload() {
            if (_this.$loading) _this.$loading.show("正在加载验证码");
          },
          function onerror(err) {
            console.log(err);
            reject();
          }
        );
      });
    }
  }
  // created() {
  //   this.$loading.show('正在加载验证码')
  //   this.verify();
  // }
};
</script>

<style lang="scss" scoped>
.captcha-wrapper {
  width: 100%;
  position: absolute;
  top: 38.2%;
  z-index: 999;
}

// .yidun_intellisense--light .yidun_classic-container{
//   position: absolute;
//   bottom: 0;
//   left: 50%!important;
//   width: 50%!important;
//   z-index: 1000;
//   transform: translateX(-50%);
//   -webkit-transform: translateX(-50%);
// }
</style>
